import axios from './request';
export const GetNewTechList = (params) => {
  const { m_type, page, name, title, updated_at, price, xq_type, resource_type, sd_type, type } = params
  const data = new FormData();
  data.append('page', page)
  data.append('m_type', m_type)
  data.append('title', title || name || '')
  if (m_type == 5) {
    data.append('updated_at', updated_at || '')
    data.append('price', price || '')
  }
  if (m_type == 4) {
    data.append('xq_type', xq_type)
  }
  if (m_type == 3) {
    data.append('sd_type', sd_type)
    data.append('resource_type', resource_type)
  }
  if (m_type == 2) {
    data.append('type', type)
  }

  return axios.post('/new_technique_list', data)
}


// WEBPACK FOOTER //
// ./src/request/newTech.js